import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImageAvatarSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconImageAvatarSparkle"><Path d="M18.5 1L17 4L14 5.5L17 7L18.5 10L20 7L23 5.5L20 4L18.5 1Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V21H21V12H19V19H16.9C16.4367 16.7178 14.419 15 12 15C9.58104 15 7.56329 16.7178 7.10002 19H5V5H12V3H3Z" fill="currentColor"/><Path d="M12 7.5C10.3431 7.5 9 8.84315 9 10.5C9 12.1569 10.3431 13.5 12 13.5C13.6569 13.5 15 12.1569 15 10.5C15 8.84315 13.6569 7.5 12 7.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImageAvatarSparkle;
